/* eslint-disable jsx-a11y/anchor-is-valid */

import {FC, useEffect, useState} from 'react'
//import {useIntl} from 'react-intl'
import {AnimaDireita} from '../../../../../../_metronic/assets/animation/styles'
import {useIntl} from 'react-intl'
import {KTSVG, KTCard} from '../../../../../../_metronic/helpers'
import {ChartsWidget15, ChartsWidget16} from '../../../../../../_metronic/partials/widgets'
//import axios from 'axios'
//const API_URL = process.env.REACT_APP_API_URL || 'api'
import {Skeleton} from 'primereact/skeleton'
import axios from 'axios'
import {Calendar, CalendarDateTemplateParams} from 'primereact/calendar'
import AsyncSelect from 'react-select/async'
import {colourStyles} from '../../../../../../util/styles/styles'
import {Link} from 'react-router-dom'
import {CardSystemWidgetLicenses1} from '../../../licenses/components/cards/CardSystemWidgetLicenses1'
import {insertDataTime} from '../../../../../../util/insertDataTime'

const API_URL = process.env.REACT_APP_API_URL || 'api'
interface UseOption {
  readonly value: string
  readonly label: string
  readonly color: string
  readonly isFixed?: boolean
  readonly isDisabled?: boolean
}

const ActionPlansNewWrapper: FC = () => {
  //constante hook de internacionalização
  const intl = useIntl()
  insertDataTime()
  const [project_id, setproject_id] = useState<string | undefined>(undefined)
  const [entrepreneur_id, setentrepreneur_id] = useState<string | undefined>(undefined)
  const [enterprise_type_id, setenterprise_type_id] = useState<string | undefined>(undefined)

  const [selectedProject, setSelectedProject] = useState<any>([])
  const [selectedEntrepreneurID, setSelectedEntrepreneurID] = useState([])
  const [selectedField, setSelectedField] = useState([])

  const [total, setTotal] = useState()
  const [statusValue, setStatusValue] = useState<any>()
  const [valorChart15, setValorChart15] = useState<any>()
  const [valorChart16, setValorChart16] = useState<any>()
  const [anualValorChart16, setAnualValorChart16] = useState<any>()
  const [month, setMonth] = useState<any>()
  const [year, setYear] = useState<any>()
  const [arrayDaysAcao, setArrayDaysAcao] = useState<any>()

  const [actionList, setActionList] = useState<any>()

  async function getReportsTotalConditioning(
    project_id?: string,
    entrepreneur_id?: string,
    enterprise_type_id?: string
  ) {
    let route = `
   ${API_URL}/sga/v1/widgets/action_plans/count_action_plans?${
      project_id !== undefined ? `${project_id}` : ''
    }${entrepreneur_id !== undefined ? `&${entrepreneur_id}` : ''}${
      enterprise_type_id !== undefined ? `&${enterprise_type_id}` : ''
    }
   `
    const response = await axios.get<any>(route)

    setTotal(response.data.datasets.values[0])
  }

  async function getReportsStatusConditioning(
    project_id?: string,
    entrepreneur_id?: string,
    enterprise_type_id?: string
  ) {
    let route = `
   ${API_URL}/sga/v1/widgets/action_plans/action_plan_by_status?${
      project_id !== undefined ? `${project_id}` : ''
    }${entrepreneur_id !== undefined ? `&${entrepreneur_id}` : ''}${
      enterprise_type_id !== undefined ? `&${enterprise_type_id}` : ''
    }
   `
    const response = await axios.get<any>(route)
    let color: any = ['success', 'warning', 'danger', 'success', 'info', 'dark']

    let val: any = response.data.datasets.values
    let keys: any = response.data.datasets.labels
    setStatusValue([val, keys, color])
  }

  async function getReportsChart15(
    project_id?: string,
    entrepreneur_id?: string,
    enterprise_type_id?: string,
    queryData?: string
  ): Promise<any> {
    let route = `
   ${API_URL}/sga/v1/widgets/action_plans/action_plan_expire_per_month_by_year?${
      project_id !== undefined ? `${project_id}` : ''
    }${entrepreneur_id !== undefined ? `&${entrepreneur_id}` : ''}${
      enterprise_type_id !== undefined ? `&${enterprise_type_id}` : ''
    }${queryData !== undefined ? `&${queryData}` : ''}
   `

    const response = await axios.get<any>(route)

    let [annual]: any = Object.values(response.data.datasets.values)

    let monthsValue = annual.map((e: any) => {
      return e?.count
    })

    setValorChart15(monthsValue)
    // setAnualValorChart16(custo)

    return response.data
  }

  async function getReportsChart16(
    project_id?: string,
    entrepreneur_id?: string,
    enterprise_type_id?: string,
    year?: string
  ): Promise<any> {
    let route = `
   ${API_URL}/sga/v1/widgets/action_plans/action_plan_cost?${
      project_id !== undefined ? `${project_id}` : ''
    }${entrepreneur_id !== undefined ? `&${entrepreneur_id}` : ''}${
      enterprise_type_id !== undefined ? `&${enterprise_type_id}` : ''
    }${year !== undefined ? `&${year}` : ''}
   `

    const response = await axios.get<any>(route)

    let [annual, month]: any = Object.values(response.data.datasets.values)

    let mes = month.map((e: any, index: any) => {
      return e.value
    })
    let chartMonthValues = []

    for (let i = 0; i < mes.length; i++) chartMonthValues.push(parseFloat(mes[i]))

    let toFormat: any = annual.toString().replaceAll(',', '')
    const custo = new Intl.NumberFormat('pt-BR', {
      style: 'decimal',
      currency: 'BRL',
      minimumFractionDigits: 2,
    }).format(toFormat)

    setValorChart16(chartMonthValues)
    setAnualValorChart16(custo)

    return response.data
  }

  async function getCalendarList(
    project_id?: string,
    entrepreneur_id?: string,
    enterprise_type_id?: string,
    month?: any,
    year?: any
  ) {
    let route = `${API_URL}/sga/v1/widgets/action_plans/list_action_plans?${
      project_id !== undefined ? `${project_id}` : ''
    }${entrepreneur_id !== undefined ? `&${entrepreneur_id}` : ''}${
      enterprise_type_id !== undefined ? `&${enterprise_type_id}` : ''
    }${year !== undefined ? `&year=${year}` : ''}${month !== undefined ? `&month=${month}` : ''}`

    getCalendarCard(project_id, entrepreneur_id, enterprise_type_id, month, year)

    const response = await axios.get<any>(route)
    // console.log('xxxxxxxxxxx', response.data.datasets.values)
    setActionList(response.data.datasets.values)
  }

  async function getCalendarCard(
    project_id?: string,
    entrepreneur_id?: string,
    enterprise_type_id?: string,
    month?: any,
    year?: any
  ) {
    let route = `${API_URL}/sga/v1/widgets/action_plans/action_plan_expirations_per_month?${
      project_id !== undefined ? `${project_id}` : ''
    }${entrepreneur_id !== undefined ? `&${entrepreneur_id}` : ''}${
      enterprise_type_id !== undefined ? `&${enterprise_type_id}` : ''
    }${year !== undefined ? `&year=${year}` : ''}${month !== undefined ? `&month=${month}` : ''}`
    const response = await axios.get<any>(route)
    setArrayDaysAcao(response.data.datasets.labels)
  }

  const loadOptionsProjects = (inputValue: string, callback: (options: UseOption[]) => void) => {
    setTimeout(() => {
      getProjects()
      let projects: any = []
      async function getProjects() {
        const {data} = await axios.get(API_URL + '/v1/projects/select2')
        let Response = data.results

        if (Response) {
          for (let i = 0; i < Response.length; i++) {
            const project: any = {
              value: Response[i].id,
              label: `${Response[i].code} - ${Response[i].description} `,
            }
            projects.push(project)
          }
        }
      }
      callback(projects)
    }, 1000)
  }

  const handleInputChangeProjects = (event: any) => {
    let inputValue = ''
    inputValue = event.value
    setSelectedProject(event)
    setproject_id(`project_id=${inputValue}`)
    return {inputValue}
  }

  const loadOptionsEntrepreneurs = (
    inputValue: string,
    callback: (options: UseOption[]) => void
  ) => {
    setTimeout(() => {
      getentrepreneur()
      let entrepreneur: any = []
      async function getentrepreneur() {
        const {data} = await axios.get(API_URL + '/v1/entrepreneurs/select2')
        let Response = data.results

        if (Response) {
          for (let i = 0; i < Response.length; i++) {
            const field: any = {
              value: Response[i].id,
              label: Response[i].name,
            }

            entrepreneur.push(field)
          }
        }
      }
      callback(entrepreneur)
    }, 1000)
  }

  const handleInputChangeEntrepreneurIDs = (event: any) => {
    let inputValue = ''
    inputValue = event.value
    setSelectedEntrepreneurID(event)
    setentrepreneur_id(`entrepreneur_id=${inputValue}`)
    return {inputValue}
  }

  const loadOptionsFields = (inputValue: string, callback: (options: UseOption[]) => void) => {
    setTimeout(() => {
      getFields()
      let fields: any = []
      async function getFields() {
        const {data} = await axios.get(API_URL + '/v1/fields/select2')
        let Response = data.results

        for (let i = 0; i < Response.length; i++) {
          const enterprise: any = {
            value: Response[i].id,
            label: `${Response[i].name} - ${Response[i].description}`,
          }

          fields.push(enterprise)
        }
      }
      callback(fields)
    }, 1000)
  }

  const handleInputChangeEnterprises_Types = (event: any) => {
    let inputValue = ''
    inputValue = event.value
    setSelectedField(event)
    setenterprise_type_id(`field_id=${inputValue}`)
    return {inputValue}
  }

  const dateTemplate = (date: any, dayArraysAcao?: any) => {
    setMonth(date.month + 1)

    if (dayArraysAcao !== undefined && dayArraysAcao.includes(date.day)) {
      return (
        <div>
          {date.day}
          <p
            style={{
              background: 'red',
              borderRadius: '100%',
              width: '4px',
              height: '4px',
              marginBottom: '-4px',
              marginLeft: '2px',
            }}
          ></p>
        </div>
      )
    }

    if (date.year !== date.year) {
      setYear(date.year)
    }
    return date.day
  }

  useEffect(() => {
    getReportsTotalConditioning()
    getReportsStatusConditioning()
    getCalendarList()
    getReportsChart15()
    getReportsChart16()
  }, [])

  useEffect(() => {
    getCalendarList(project_id, entrepreneur_id, enterprise_type_id, month, year)
    // react-hooks/exhaustive-deps
  }, [month])

  const filterData = (
    project_id?: any,
    entrepreneur_id?: any,
    enterprise_type_id?: any,
    dateChart14?: any
  ) => {
    getReportsChart15(project_id, entrepreneur_id, enterprise_type_id, dateChart14)
    getReportsChart16(project_id, entrepreneur_id, enterprise_type_id, dateChart14)
    getReportsTotalConditioning(project_id, entrepreneur_id, enterprise_type_id)
    getReportsStatusConditioning(project_id, entrepreneur_id, enterprise_type_id)
    getCalendarList(project_id, entrepreneur_id, enterprise_type_id, month, year)
  }

  const resetData = () => {
    const initSelect: any = {
      value: '',
      label: intl.formatMessage({id: 'COMMON.ALL'}),
    }
    setproject_id(undefined)
    setentrepreneur_id(undefined)
    setenterprise_type_id(undefined)
    setMonth(undefined)
    setYear(undefined)
    setValorChart15(undefined)
    setValorChart16(undefined)
    setSelectedProject(initSelect)
    setSelectedEntrepreneurID(initSelect)
    setSelectedField(initSelect)
    filterData()
  }
  return (
    <>
      <AnimaDireita>
        <KTCard>
          <div className='row p-5 mt-3'>
            <div className='col-lg-4'>
              <label className='form-label  fw-bold'>
                {intl.formatMessage({id: 'PROJECT.PROJECT_PLURAL'})}
              </label>
              <div className='d-flex align-items-center position-relative'>
                <AsyncSelect
                  className='form-control form-control-sm form-control-solid p-0 ps-3'
                  data-kt-license-table-filter='project_id'
                  isClearable
                  styles={colourStyles}
                  cacheOptions
                  loadOptions={loadOptionsProjects}
                  filterOption={(option, inputValue) =>
                    option.label
                      ? option.label.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0
                      : false
                  }
                  defaultOptions
                  placeholder={intl.formatMessage({id: 'PROJECT.PROJECT_PLURAL'})}
                  value={selectedProject}
                  onChange={handleInputChangeProjects}
                />
              </div>
            </div>

            <div className='col-lg-4'>
              <label className='form-label  fw-bold'>
                {intl.formatMessage({id: 'ENTERPRISES.INPUT_FIELDS'})}
              </label>
              <div className='d-flex align-items-center position-relative'>
                <AsyncSelect
                  className='form-control form-control-sm form-control-solid p-0 ps-3'
                  data-kt-license-table-filter='entrepreneur_id'
                  styles={colourStyles}
                  cacheOptions
                  loadOptions={loadOptionsFields}
                  filterOption={(option, inputValue) =>
                    option.label
                      ? option.label.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0
                      : false
                  }
                  defaultOptions
                  placeholder={
                    intl.formatMessage({id: 'COMMON.SEARCH'}) +
                    ' ' +
                    intl.formatMessage({id: 'ENTERPRISES.INPUT_FIELDS'})
                  }
                  value={selectedField}
                  onChange={handleInputChangeEnterprises_Types}
                />
              </div>
            </div>

            <div className='col-lg-4'>
              <label className='form-label  fw-bold'>
                {intl.formatMessage({id: 'ENTREPRENEUR.ENTREPRENEUR_SINGLE'})}
              </label>
              <div className='d-flex align-items-center position-relative'>
                <AsyncSelect
                  className='form-control form-control-sm form-control-solid p-0 ps-3'
                  data-kt-license-table-filter='entrepreneur_id'
                  styles={colourStyles}
                  cacheOptions
                  loadOptions={loadOptionsEntrepreneurs}
                  filterOption={(option, inputValue) =>
                    option.label
                      ? option.label.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0
                      : false
                  }
                  isClearable
                  defaultOptions
                  placeholder={
                    intl.formatMessage({id: 'COMMON.SEARCH'}) +
                    ' ' +
                    intl.formatMessage({id: 'ENTREPRENEUR.ENTREPRENEUR_SINGLE'})
                  }
                  value={selectedEntrepreneurID}
                  onChange={handleInputChangeEntrepreneurIDs}
                />
                <button
                  type='button'
                  className='btn btn-sm btn-icon btn-light-danger p-3 m-1'
                  title='Limpar Busca'
                  onClick={resetData}
                >
                  <KTSVG path='/media/icons/duotune/art/art004.svg' className='svg-icon-3' />
                </button>
                <button
                  type='button'
                  onClick={() => filterData(project_id, entrepreneur_id, enterprise_type_id)}
                  className='btn btn-sm btn-primary fs-9 px-3 m-1'
                  title='Filtar'
                >
                  {intl.formatMessage({id: 'COMMON.SEARCH'})}
                </button>
              </div>
            </div>
          </div>
        </KTCard>

        <div className='row mt-3'>
          <div
            className='card card-xl-stretched col-12 col-xxl-4 col-xl-6 col-lg-6 '
            style={{
              height: '350px',
            }}
          >
            <a className='fw-bolder mx-5 mt-5 pb-2 text-gray-800 fs-6'>Status das Ações</a>
            <div
              className=' mb-5 mb-xl-8 p-3'
              style={{
                overflow: 'auto',
              }}
            >
              {total !== undefined ? (
                <CardSystemWidgetLicenses1 title='Total de Ações' value={total} color='primary' />
              ) : (
                <div className='card row ms-1'>
                  <div className='d-flex justify-content-between mb-3'>
                    <Skeleton size='4rem' className='d-flex '></Skeleton>
                    <div>
                      <Skeleton width='350px' className='mb-2'></Skeleton>
                      <Skeleton width='50%' className='mb-2'></Skeleton>
                    </div>
                    <Skeleton size='3rem' className='d-flex justify-content-end'></Skeleton>
                  </div>
                  <div className='d-flex justify-content-between mb-3'>
                    <Skeleton size='4rem' className='d-flex '></Skeleton>
                    <div>
                      <Skeleton width='350px' className='mb-2'></Skeleton>
                      <Skeleton width='50%' className='mb-2'></Skeleton>
                    </div>
                    <Skeleton size='3rem' className='d-flex justify-content-end'></Skeleton>
                  </div>
                  <div className='d-flex justify-content-between mb-3'>
                    <Skeleton size='4rem' className='d-flex '></Skeleton>
                    <div>
                      <Skeleton width='350px' className='mb-2'></Skeleton>
                      <Skeleton width='50%' className='mb-2'></Skeleton>
                    </div>
                    <Skeleton size='3rem' className='d-flex justify-content-end'></Skeleton>
                  </div>
                  <div className='d-flex justify-content-between mb-3'>
                    <Skeleton size='4rem' className='d-flex '></Skeleton>
                    <div>
                      <Skeleton width='350px' className='mb-2'></Skeleton>
                      <Skeleton width='50%' className='mb-2'></Skeleton>
                    </div>
                    <Skeleton size='3rem' className='d-flex justify-content-end'></Skeleton>
                  </div>
                </div>
              )}
              {statusValue !== undefined ? (
                <>
                  <CardSystemWidgetLicenses1
                    value={statusValue[0][0]}
                    title={statusValue[1][0]}
                    color={statusValue[2][0]}
                  />
                  <CardSystemWidgetLicenses1
                    value={statusValue[0][1]}
                    title={statusValue[1][1]}
                    color={statusValue[2][1]}
                  />
                  <CardSystemWidgetLicenses1
                    value={statusValue[0][2]}
                    title={statusValue[1][2]}
                    color={statusValue[2][2]}
                  />
                  <CardSystemWidgetLicenses1
                    value={statusValue[0][3]}
                    title={statusValue[1][3]}
                    color={statusValue[2][3]}
                  />
                  <CardSystemWidgetLicenses1
                    value={statusValue[0][4]}
                    title={statusValue[1][4]}
                    color={statusValue[2][4]}
                  />
                  <CardSystemWidgetLicenses1
                    value={statusValue[0][5]}
                    title={statusValue[1][5]}
                    color={statusValue[2][5]}
                  />
                </>
              ) : (
                <div className='card row ms-1'>
                  <div className='d-flex justify-content-between mb-3'>
                    <Skeleton size='4rem' className='d-flex '></Skeleton>
                    <div>
                      <Skeleton width='350px' className='mb-2'></Skeleton>
                      <Skeleton width='50%' className='mb-2'></Skeleton>
                    </div>
                    <Skeleton size='3rem' className='d-flex justify-content-end'></Skeleton>
                  </div>
                  <div className='d-flex justify-content-between mb-3'>
                    <Skeleton size='4rem' className='d-flex '></Skeleton>
                    <div>
                      <Skeleton width='350px' className='mb-2'></Skeleton>
                      <Skeleton width='50%' className='mb-2'></Skeleton>
                    </div>
                    <Skeleton size='3rem' className='d-flex justify-content-end'></Skeleton>
                  </div>
                  <div className='d-flex justify-content-between mb-3'>
                    <Skeleton size='4rem' className='d-flex '></Skeleton>
                    <div>
                      <Skeleton width='350px' className='mb-2'></Skeleton>
                      <Skeleton width='50%' className='mb-2'></Skeleton>
                    </div>
                    <Skeleton size='3rem' className='d-flex justify-content-end'></Skeleton>
                  </div>
                  <div className='d-flex justify-content-between mb-3'>
                    <Skeleton size='4rem' className='d-flex '></Skeleton>
                    <div>
                      <Skeleton width='350px' className='mb-2'></Skeleton>
                      <Skeleton width='50%' className='mb-2'></Skeleton>
                    </div>
                    <Skeleton size='3rem' className='d-flex justify-content-end'></Skeleton>
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className='col-12 col-xxl-8 col-xl-8 col-lg-8 mt-5 mt-sm-3 mt-lg-0'>
            <div className='card h-100'>
              {valorChart16 !== undefined ? (
                <>
                  <div className='d-flex px-2 align-items-center justify-content-between fw-bolder fs-4 m-5 mb-5'>
                    <span className='px-2  mt-n10'>Custo com Ações</span>
                    {/* Inicio Calendário*/}
                    <div className='row w-160px'>
                      <Calendar
                        inputClassName='form-control form-control-sm form-control-solid
               text-primary text-center
               bg-light-primary  w-25px
               fw-semibold fs-6 border border-0'
                        id='monthCost'
                        view='year'
                        panelStyle={{
                          minWidth: '150px',
                        }}
                        dateFormat='yy'
                        showIcon
                        icon={
                          <svg
                            width='24'
                            height='24'
                            viewBox='0 0 24 24'
                            fill='none'
                            xmlns='http://www.w3.org/2000/svg'
                          >
                            <path
                              opacity='0.3'
                              d='M21 22H3C2.4 22 2 21.6 2 21V5C2 4.4 2.4 4 3 4H21C21.6 4 22 4.4 22 5V21C22 21.6 21.6 22 21 22Z'
                              fill='currentColor'
                            />
                            <path
                              d='M6 6C5.4 6 5 5.6 5 5V3C5 2.4 5.4 2 6 2C6.6 2 7 2.4 7 3V5C7 5.6 6.6 6 6 6ZM11 5V3C11 2.4 10.6 2 10 2C9.4 2 9 2.4 9 3V5C9 5.6 9.4 6 10 6C10.6 6 11 5.6 11 5ZM15 5V3C15 2.4 14.6 2 14 2C13.4 2 13 2.4 13 3V5C13 5.6 13.4 6 14 6C14.6 6 15 5.6 15 5ZM19 5V3C19 2.4 18.6 2 18 2C17.4 2 17 2.4 17 3V5C17 5.6 17.4 6 18 6C18.6 6 19 5.6 19 5Z'
                              fill='currentColor'
                            />
                            <path
                              d='M8.8 13.1C9.2 13.1 9.5 13 9.7 12.8C9.9 12.6 10.1 12.3 10.1 11.9C10.1 11.6 10 11.3 9.8 11.1C9.6 10.9 9.3 10.8 9 10.8C8.8 10.8 8.59999 10.8 8.39999 10.9C8.19999 11 8.1 11.1 8 11.2C7.9 11.3 7.8 11.4 7.7 11.6C7.6 11.8 7.5 11.9 7.5 12.1C7.5 12.2 7.4 12.2 7.3 12.3C7.2 12.4 7.09999 12.4 6.89999 12.4C6.69999 12.4 6.6 12.3 6.5 12.2C6.4 12.1 6.3 11.9 6.3 11.7C6.3 11.5 6.4 11.3 6.5 11.1C6.6 10.9 6.8 10.7 7 10.5C7.2 10.3 7.49999 10.1 7.89999 10C8.29999 9.90003 8.60001 9.80003 9.10001 9.80003C9.50001 9.80003 9.80001 9.90003 10.1 10C10.4 10.1 10.7 10.3 10.9 10.4C11.1 10.5 11.3 10.8 11.4 11.1C11.5 11.4 11.6 11.6 11.6 11.9C11.6 12.3 11.5 12.6 11.3 12.9C11.1 13.2 10.9 13.5 10.6 13.7C10.9 13.9 11.2 14.1 11.4 14.3C11.6 14.5 11.8 14.7 11.9 15C12 15.3 12.1 15.5 12.1 15.8C12.1 16.2 12 16.5 11.9 16.8C11.8 17.1 11.5 17.4 11.3 17.7C11.1 18 10.7 18.2 10.3 18.3C9.9 18.4 9.5 18.5 9 18.5C8.5 18.5 8.1 18.4 7.7 18.2C7.3 18 7 17.8 6.8 17.6C6.6 17.4 6.4 17.1 6.3 16.8C6.2 16.5 6.10001 16.3 6.10001 16.1C6.10001 15.9 6.2 15.7 6.3 15.6C6.4 15.5 6.6 15.4 6.8 15.4C6.9 15.4 7.00001 15.4 7.10001 15.5C7.20001 15.6 7.3 15.6 7.3 15.7C7.5 16.2 7.7 16.6 8 16.9C8.3 17.2 8.6 17.3 9 17.3C9.2 17.3 9.5 17.2 9.7 17.1C9.9 17 10.1 16.8 10.3 16.6C10.5 16.4 10.5 16.1 10.5 15.8C10.5 15.3 10.4 15 10.1 14.7C9.80001 14.4 9.50001 14.3 9.10001 14.3C9.00001 14.3 8.9 14.3 8.7 14.3C8.5 14.3 8.39999 14.3 8.39999 14.3C8.19999 14.3 7.99999 14.2 7.89999 14.1C7.79999 14 7.7 13.8 7.7 13.7C7.7 13.5 7.79999 13.4 7.89999 13.2C7.99999 13 8.2 13 8.5 13H8.8V13.1ZM15.3 17.5V12.2C14.3 13 13.6 13.3 13.3 13.3C13.1 13.3 13 13.2 12.9 13.1C12.8 13 12.7 12.8 12.7 12.6C12.7 12.4 12.8 12.3 12.9 12.2C13 12.1 13.2 12 13.6 11.8C14.1 11.6 14.5 11.3 14.7 11.1C14.9 10.9 15.2 10.6 15.5 10.3C15.8 10 15.9 9.80003 15.9 9.70003C15.9 9.60003 16.1 9.60004 16.3 9.60004C16.5 9.60004 16.7 9.70003 16.8 9.80003C16.9 9.90003 17 10.2 17 10.5V17.2C17 18 16.7 18.4 16.2 18.4C16 18.4 15.8 18.3 15.6 18.2C15.4 18.1 15.3 17.8 15.3 17.5Z'
                              fill='currentColor'
                            />
                          </svg>
                        }
                        onChange={(e: any) => {
                          let year = new Date(e.target.value)
                          getReportsChart16(
                            project_id,
                            entrepreneur_id,
                            enterprise_type_id,
                            `year=${year.getFullYear()}`
                          )
                        }}
                      />
                      <span className='mt-2 text-center fs-3 text-primary'>
                        R$ {anualValorChart16}
                      </span>
                    </div>
                  </div>
                  <ChartsWidget16
                    className=''
                    valorChart={valorChart16}
                    title='Custos com Anuidades'
                  />
                </>
              ) : (
                <div className='card row w-100 ms-1 h-100'>
                  <h5 className='card-title align-items-start flex-column pt-5 px-8 pb-0'>
                    <span className='card-label fw-bolder mb-1'>Custo com Ações</span>
                  </h5>
                  <div className='d-flex justify-content-center align-content-end align-items-end mt-5'>
                    <Skeleton width='15px' height='25px' className=' ms-5'></Skeleton>
                    <Skeleton width='15px' height='50px' className=' ms-5'></Skeleton>
                    <Skeleton width='15px' height='100px' className=' ms-5'></Skeleton>
                    <Skeleton width='15px' height='250px' className=' ms-5'></Skeleton>
                    <Skeleton width='15px' height='200px' className=' ms-5'></Skeleton>
                    <Skeleton width='15px' height='150px' className=' ms-5'></Skeleton>
                    <Skeleton width='15px' height='200px' className=' ms-5'></Skeleton>
                    <Skeleton width='15px' height='250px' className=' ms-5'></Skeleton>
                    <Skeleton width='15px' height='200px' className=' ms-5'></Skeleton>
                    <Skeleton width='15px' height='150px' className=' ms-5'></Skeleton>
                    <Skeleton width='15px' height='200px' className=' ms-5'></Skeleton>
                    <Skeleton width='15px' height='150px' className=' ms-5'></Skeleton>
                    <Skeleton width='15px' height='100px' className=' ms-5'></Skeleton>
                    <Skeleton width='15px' height='50px' className=' ms-5'></Skeleton>
                    <Skeleton width='15px' height='25px' className=' ms-5'></Skeleton>
                  </div>
                  <Skeleton
                    height='5px'
                    className='d-flex justify-content-center align-content-end align-items-end'
                  ></Skeleton>
                </div>
              )}
            </div>
          </div>

          <div className='col-12 mt-3 col-xxl-6 col-xl-12 col-lg-12  '>
            {valorChart15 !== undefined ? (
              <>
                <div className='card h-100'>
                  <div className='d-flex px-2 align-items-center justify-content-between fw-bolder fs-4 m-5 mb-5'>
                    <span className='px-2'>Ações a vencer por meses</span>
                    {/* Inicio Calendário*/}
                    <Calendar
                      inputClassName='form-control form-control-sm form-control-solid
                  text-primary text-center
                  bg-light-primary  w-50px
                  fw-semibold fs-6 border border-0'
                      id='yearpicker'
                      view='year'
                      panelStyle={{
                        minWidth: '150px',
                      }}
                      dateFormat='yy'
                      showIcon
                      icon={
                        <svg
                          width='24'
                          height='24'
                          viewBox='0 0 24 24'
                          fill='none'
                          xmlns='http://www.w3.org/2000/svg'
                        >
                          <path
                            opacity='0.3'
                            d='M21 22H3C2.4 22 2 21.6 2 21V5C2 4.4 2.4 4 3 4H21C21.6 4 22 4.4 22 5V21C22 21.6 21.6 22 21 22Z'
                            fill='currentColor'
                          />
                          <path
                            d='M6 6C5.4 6 5 5.6 5 5V3C5 2.4 5.4 2 6 2C6.6 2 7 2.4 7 3V5C7 5.6 6.6 6 6 6ZM11 5V3C11 2.4 10.6 2 10 2C9.4 2 9 2.4 9 3V5C9 5.6 9.4 6 10 6C10.6 6 11 5.6 11 5ZM15 5V3C15 2.4 14.6 2 14 2C13.4 2 13 2.4 13 3V5C13 5.6 13.4 6 14 6C14.6 6 15 5.6 15 5ZM19 5V3C19 2.4 18.6 2 18 2C17.4 2 17 2.4 17 3V5C17 5.6 17.4 6 18 6C18.6 6 19 5.6 19 5Z'
                            fill='currentColor'
                          />
                          <path
                            d='M8.8 13.1C9.2 13.1 9.5 13 9.7 12.8C9.9 12.6 10.1 12.3 10.1 11.9C10.1 11.6 10 11.3 9.8 11.1C9.6 10.9 9.3 10.8 9 10.8C8.8 10.8 8.59999 10.8 8.39999 10.9C8.19999 11 8.1 11.1 8 11.2C7.9 11.3 7.8 11.4 7.7 11.6C7.6 11.8 7.5 11.9 7.5 12.1C7.5 12.2 7.4 12.2 7.3 12.3C7.2 12.4 7.09999 12.4 6.89999 12.4C6.69999 12.4 6.6 12.3 6.5 12.2C6.4 12.1 6.3 11.9 6.3 11.7C6.3 11.5 6.4 11.3 6.5 11.1C6.6 10.9 6.8 10.7 7 10.5C7.2 10.3 7.49999 10.1 7.89999 10C8.29999 9.90003 8.60001 9.80003 9.10001 9.80003C9.50001 9.80003 9.80001 9.90003 10.1 10C10.4 10.1 10.7 10.3 10.9 10.4C11.1 10.5 11.3 10.8 11.4 11.1C11.5 11.4 11.6 11.6 11.6 11.9C11.6 12.3 11.5 12.6 11.3 12.9C11.1 13.2 10.9 13.5 10.6 13.7C10.9 13.9 11.2 14.1 11.4 14.3C11.6 14.5 11.8 14.7 11.9 15C12 15.3 12.1 15.5 12.1 15.8C12.1 16.2 12 16.5 11.9 16.8C11.8 17.1 11.5 17.4 11.3 17.7C11.1 18 10.7 18.2 10.3 18.3C9.9 18.4 9.5 18.5 9 18.5C8.5 18.5 8.1 18.4 7.7 18.2C7.3 18 7 17.8 6.8 17.6C6.6 17.4 6.4 17.1 6.3 16.8C6.2 16.5 6.10001 16.3 6.10001 16.1C6.10001 15.9 6.2 15.7 6.3 15.6C6.4 15.5 6.6 15.4 6.8 15.4C6.9 15.4 7.00001 15.4 7.10001 15.5C7.20001 15.6 7.3 15.6 7.3 15.7C7.5 16.2 7.7 16.6 8 16.9C8.3 17.2 8.6 17.3 9 17.3C9.2 17.3 9.5 17.2 9.7 17.1C9.9 17 10.1 16.8 10.3 16.6C10.5 16.4 10.5 16.1 10.5 15.8C10.5 15.3 10.4 15 10.1 14.7C9.80001 14.4 9.50001 14.3 9.10001 14.3C9.00001 14.3 8.9 14.3 8.7 14.3C8.5 14.3 8.39999 14.3 8.39999 14.3C8.19999 14.3 7.99999 14.2 7.89999 14.1C7.79999 14 7.7 13.8 7.7 13.7C7.7 13.5 7.79999 13.4 7.89999 13.2C7.99999 13 8.2 13 8.5 13H8.8V13.1ZM15.3 17.5V12.2C14.3 13 13.6 13.3 13.3 13.3C13.1 13.3 13 13.2 12.9 13.1C12.8 13 12.7 12.8 12.7 12.6C12.7 12.4 12.8 12.3 12.9 12.2C13 12.1 13.2 12 13.6 11.8C14.1 11.6 14.5 11.3 14.7 11.1C14.9 10.9 15.2 10.6 15.5 10.3C15.8 10 15.9 9.80003 15.9 9.70003C15.9 9.60003 16.1 9.60004 16.3 9.60004C16.5 9.60004 16.7 9.70003 16.8 9.80003C16.9 9.90003 17 10.2 17 10.5V17.2C17 18 16.7 18.4 16.2 18.4C16 18.4 15.8 18.3 15.6 18.2C15.4 18.1 15.3 17.8 15.3 17.5Z'
                            fill='currentColor'
                          />
                        </svg>
                      }
                      onChange={(e: any) => {
                        let year = new Date(e.target.value)
                        getReportsChart15(
                          project_id,
                          entrepreneur_id,
                          enterprise_type_id,
                          `year=${year.getFullYear()}`
                        )
                      }}
                    />
                  </div>
                  <ChartsWidget15 className='' chartValue={valorChart15} />
                </div>
              </>
            ) : (
              <div className='card row w-100 ms-1 h-100'>
                <h5 className='card-title align-items-start flex-column pt-5 my-5 px-8 pb-0'>
                  <span className='card-label fw-bolder mb-1'>Licenças Renovadas</span>
                </h5>
                <div className='d-flex justify-content-center align-content-end align-items-end mt-5'>
                  <Skeleton width='15px' height='25px' className=' ms-5'></Skeleton>
                  <Skeleton width='15px' height='50px' className=' ms-5'></Skeleton>
                  <Skeleton width='15px' height='100px' className=' ms-5'></Skeleton>
                  <Skeleton width='15px' height='250px' className=' ms-5'></Skeleton>
                  <Skeleton width='15px' height='200px' className=' ms-5'></Skeleton>
                  <Skeleton width='15px' height='150px' className=' ms-5'></Skeleton>
                  <Skeleton width='15px' height='200px' className=' ms-5'></Skeleton>
                  <Skeleton width='15px' height='250px' className=' ms-5'></Skeleton>
                  <Skeleton width='15px' height='200px' className=' ms-5'></Skeleton>
                  <Skeleton width='15px' height='150px' className=' ms-5'></Skeleton>
                  <Skeleton width='15px' height='200px' className=' ms-5'></Skeleton>
                  <Skeleton width='15px' height='150px' className=' ms-5'></Skeleton>
                  <Skeleton width='15px' height='100px' className=' ms-5'></Skeleton>
                  <Skeleton width='15px' height='50px' className=' ms-5'></Skeleton>
                  <Skeleton width='15px' height='25px' className=' ms-5'></Skeleton>
                </div>
                <Skeleton
                  height='5px'
                  className='d-flex justify-content-center align-content-end align-items-end'
                ></Skeleton>
              </div>
            )}
          </div>

          <div className='col-12 col-lg-12 col-xxl-6 col-xl-12  mt-3'>
            <div
              className='card shadow card-xl-stretch mb-5 mb-xl-8 h-100'
              style={{
                maxHeight: '600px',
              }}
            >
              <div className='card-header border-0'>
                <h4 className='card-title d-flex align-items-start flex-column'>
                  <span className='card-label fw-bolder text-gray-800'>
                    Calendário de Vencimentos
                  </span>
                  <span className='text-gray-400 mt-1 fw-bolder fs-7'>
                    Vencimentos nos Proximos 30 dias
                  </span>
                </h4>
              </div>

              <div className='d-flex p-0'>
                <div className='d-flex col-xxl-5 col-lg-5 border-gray-100'>
                  <Calendar
                    id='datetemplate'
                    inline
                    className='mx-3'
                    dateTemplate={(e: CalendarDateTemplateParams) => dateTemplate(e, arrayDaysAcao)}
                    panelClassName='w-100'
                    showOtherMonths={false}
                  />
                </div>

                {actionList !== undefined ? (
                  <div
                    className='col-xxl-7 col-lg-7 px-10 mx-0 overflow-auto'
                    style={{
                      maxHeight: '350px',
                      minHeight: '350px',
                    }}
                  >
                    {actionList.length > 0 ? (
                      <div>
                        {actionList.map((actionPlan: any) => {
                          return (
                            <div
                              className='d-flex align-items-center bg-light-primary rounded p-5 mb-7 w-100'
                              key={actionPlan.conditioning_id}
                            >
                              <span className='svg-icon svg-icon-success me-5'>
                                <KTSVG
                                  path='/media/icons/duotune/general/gen005.svg'
                                  className='svg-icon-1'
                                />
                              </span>

                              <div className='flex-grow-1 me-2 '>
                                <p className='fw-bold fs-7 mb-0'>
                                  Ação Nº
                                  <Link
                                    to={`/editactionplans/${actionPlan.action_plan_uuid}/${actionPlan.conditioning_uuid}`}
                                    className='fw-bolder'
                                  >
                                    {' '}
                                    {actionPlan.action_plan_id}
                                  </Link>
                                </p>
                                <p className='fw-bold fs-7 mb-0'>
                                  Condicionante Nº
                                  <Link
                                    to={`/editconditioning/${actionPlan.license_id}/${actionPlan.conditioning_uuid}/${actionPlan.license_uuid}`}
                                    className='fw-bolder'
                                  >
                                    {' '}
                                    {actionPlan.conditioning_number}
                                  </Link>
                                </p>
                                <p className='fw-bold fs-7 mb-0'>
                                  Licença Nº{' '}
                                  <Link
                                    to={`/editlicenses/${actionPlan.license_id}/${actionPlan.license_uuid}`}
                                    className='fw-bolder'
                                  >
                                    {' '}
                                    {actionPlan.license_number}
                                  </Link>
                                </p>

                                {actionPlan.days_remaining > 0 ? (
                                  <span className='text-success fs-8 fw-bold d-block'>
                                    Vencimento em {actionPlan.days_remaining} dias
                                  </span>
                                ) : (
                                  <span className='text-danger fs-8 fw-bold d-block'>
                                    {`Venceu há ${actionPlan.days_remaining
                                      .toString()
                                      .replaceAll('-', '')} dias.`}
                                  </span>
                                )}
                              </div>
                            </div>
                          )
                        })}
                      </div>
                    ) : (
                      <div
                        className='d-flex'
                        style={{
                          maxHeight: '350px',
                          minHeight: '350px',
                        }}
                      >
                        <div className='d-flex align-items-center bg-light rounded p-5 mb-7 w-100'>
                          <div className='flex-grow-1 me-2 text-center '>
                            <strong className='fs-7'>Não existem vencimentos para este mês</strong>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                ) : (
                  <div className='card row ms-5'>
                    <div className='d-flex justify-content-between mb-3'>
                      <Skeleton size='4rem' className='d-flex '></Skeleton>
                      <div>
                        <Skeleton width='250px' className='mb-2'></Skeleton>
                        <Skeleton width='50%' className='mb-2'></Skeleton>
                      </div>
                      <Skeleton size='3rem' className='d-flex justify-content-end'></Skeleton>
                    </div>
                    <div className='d-flex justify-content-between mb-3'>
                      <Skeleton size='4rem' className='d-flex '></Skeleton>
                      <div>
                        <Skeleton width='250px' className='mb-2'></Skeleton>
                        <Skeleton width='50%' className='mb-2'></Skeleton>
                      </div>
                      <Skeleton size='3rem' className='d-flex justify-content-end'></Skeleton>
                    </div>
                    <div className='d-flex justify-content-between mb-3'>
                      <Skeleton size='4rem' className='d-flex '></Skeleton>
                      <div>
                        <Skeleton width='250px' className='mb-2'></Skeleton>
                        <Skeleton width='50%' className='mb-2'></Skeleton>
                      </div>
                      <Skeleton size='3rem' className='d-flex justify-content-end'></Skeleton>
                    </div>
                    <div className='d-flex justify-content-between mb-3'>
                      <Skeleton size='4rem' className='d-flex '></Skeleton>
                      <div>
                        <Skeleton width='250px' className='mb-2'></Skeleton>
                        <Skeleton width='50%' className='mb-2'></Skeleton>
                      </div>
                      <Skeleton size='3rem' className='d-flex justify-content-end'></Skeleton>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </AnimaDireita>
    </>
  )
}
export {ActionPlansNewWrapper}
